// Module
var code = "<md-button class=\"md-icon-button md-primary show-button draft-view-settings-button\" ng-click=\"$ctrl.onShowPanel($event)\"> <md-icon md-svg-icon=\"settings-outline\" class=\"bringoz-icon\"></md-icon> <md-tooltip>{{'View Settings' | translate}}</md-tooltip> </md-button> ";
// Exports
export default code;